/**
 * Analytics — unified tracker for GA4 + Meta Pixel.
 * Fire-and-forget: safe to call even if scripts haven't loaded / IDs not set.
 */

const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || "";
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

let initialised = false;

export function initAnalytics() {
  if (initialised || typeof window === "undefined") return;
  initialised = true;
  // Both GA4 (gtag) and Meta Pixel (fbq) are loaded via <script> in public/index.html.
  // No JS-side initialisation needed. This function is kept for API compatibility.
}

/** Fire a page_view on SPA route change. */
export function trackPageView(path, title) {
  if (typeof window === "undefined") return;
  if (window.gtag) {
    window.gtag("event", "page_view", { page_path: path, page_title: title });
  }
  if (window.fbq) {
    window.fbq("track", "PageView");
  }
}

/** Track a custom event to both GA4 and Meta Pixel. */
export function track(name, params = {}) {
  if (typeof window === "undefined") return;
  if (window.gtag) {
    window.gtag("event", name, params);
  }
  if (window.fbq) {
    // Map to Meta standard events where possible
    const map = {
      newsletter_signup: ["Subscribe", { content_name: params.source || "newsletter" }],
      free_download_requested: ["Lead", { content_name: params.resource_slug, content_category: "free-download" }],
      checkout_initiated: ["InitiateCheckout", { content_name: params.resource_slug, value: params.value, currency: "USD" }],
      purchase_completed: ["Purchase", { content_name: params.resource_slug, value: params.value, currency: "USD" }],
      faq_expanded: ["ViewContent", { content_name: params.question, content_category: "faq" }],
      article_read: ["ViewContent", { content_name: params.slug, content_category: "article" }],
    };
    const mapped = map[name];
    if (mapped) {
      window.fbq("track", mapped[0], mapped[1] || {});
    } else {
      window.fbq("trackCustom", name, params);
    }
  }
}

// Convenience wrappers
export const analytics = {
  newsletterSignup: (source) => track("newsletter_signup", { source }),
  freeDownload: (slug) => track("free_download_requested", { resource_slug: slug }),
  checkoutInitiated: (slug, value) => track("checkout_initiated", { resource_slug: slug, value }),
  purchaseCompleted: (slug, value) => track("purchase_completed", { resource_slug: slug, value }),
  faqExpanded: (question) => track("faq_expanded", { question }),
  articleRead: (slug) => track("article_read", { slug }),
};
